import { render, staticRenderFns } from "./proofTagsDialog.vue?vue&type=template&id=c6645440"
import script from "./proofTagsDialog.vue?vue&type=script&lang=js"
export * from "./proofTagsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports